"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pagination.step': '步骤',
    'onboarding.pagination.step.1': '步骤 1',
    'onboarding.pagination.navigation': '入职导航',
};
